import { useStoneDeviceList } from '@/core/domain/stone/devices/devices.hooks';
import { StoneDevice } from '@/core/domain/stone/devices/devices.types';
import { useStoneOrderHasOpenMutate } from '@/core/domain/stone/orders/orders.hooks';
import {
  StoneOrderHasOpenOrderResponse,
  StoneOrderOriginType,
} from '@/core/domain/stone/orders/orders.types';
import { useCallback } from 'react';

export interface UseHasStoneDeviceProcessProps {
  companyId?: number;
  originId?: number;
  originType: StoneOrderOriginType;
}

export interface UseHasStoneDeviceProcessCallback {
  device: StoneDevice;
  orderInfo: StoneOrderHasOpenOrderResponse;
}

export default function useHasStoneDeviceProcess(
  props: UseHasStoneDeviceProcessProps,
) {
  const stoneDevices = useStoneDeviceList({
    companyId: props.companyId,
    isActive: true,
  });
  const stoneHasOrderInfo = useStoneOrderHasOpenMutate();

  const devices = stoneDevices.data || [];

  return useCallback(
    async (cbk: (data?: UseHasStoneDeviceProcessCallback) => void) => {
      const results = await Promise.all(
        devices.map(async (device) => {
          const orderInfo = await stoneHasOrderInfo.mutateAsync(device.id);
          return {
            device,
            orderInfo,
          };
        }),
      );

      cbk(
        results.find(
          ({ orderInfo }) =>
            orderInfo.hasOpenOrder &&
            orderInfo.originId === props.originId &&
            orderInfo.originType === props.originType,
        ),
      );
    },
    [devices, stoneDevices.dataUpdatedAt],
  );
}
